import { useEffect, useState } from "react";
import { Repeat, Calendar } from "lucide-react";
import { myApi } from "../api";

export default function MySubscriptions() {
  const [subs, setSubs] = useState(null);

  useEffect(() => { myApi.subscriptions().then(setSubs).catch(() => setSubs([])); }, []);

  return (
    <div data-testid="my-subscriptions-page" className="space-y-6">
      <div>
        <h1 className="text-4xl text-[#0F1829] mb-1" style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}>
          Subscrições
        </h1>
        <p className="text-sm text-[#6B7280]">As suas subscrições IHTP activas.</p>
      </div>

      {subs === null ? (
        <div className="text-sm text-[#978D78]">A carregar...</div>
      ) : subs.length === 0 ? (
        <div className="bg-white rounded-[20px] p-10 text-center border border-[#E6E1D6]">
          <Repeat size={36} className="mx-auto text-[#978D78] mb-3" strokeWidth={1.3} />
          <div className="text-sm text-[#4B5563]">Sem subscrições activas.</div>
        </div>
      ) : (
        <div className="space-y-3" data-testid="my-subs-list">
          {subs.map((s) => (
            <div
              key={s.ID_Subscricao}
              data-testid={`my-sub-${s.ID_Subscricao}`}
              className="bg-white rounded-[20px] border border-[#E6E1D6] p-5 flex items-center gap-4"
            >
              <div className="w-12 h-12 rounded-full bg-[#6F7559]/15 text-[#6F7559] grid place-items-center">
                <Repeat size={20} strokeWidth={1.6} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm text-[#0F1829] font-medium">{s.Pack || `Subscrição #${s.ID_Subscricao}`}</div>
                <div className="text-xs text-[#978D78] flex items-center gap-3 mt-1 flex-wrap">
                  <span className="inline-flex items-center gap-1">
                    <Calendar size={11} /> Início {(s.DataInicio || "").slice(0, 10)}
                  </span>
                  {s.DataFim && <span>· Fim {(s.DataFim || "").slice(0, 10)}</span>}
                  {s.DataUltimaExecucao && <span>· Última execução {s.DataUltimaExecucao.slice(0, 10)}</span>}
                </div>
              </div>
              <span className="px-3 py-1 rounded-full text-[10px] uppercase tracking-wider bg-[#6F7559]/15 text-[#4A5E2E]">
                Activa
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
